export default "__VITE_ASSET__65f65e85__"